import { useCallback, useEffect, useState } from "react";
import { loadPepProductCatalog } from "../pep-catalog.service";
import type { PepCatalogSource } from "../pep-catalog.types";

export interface UseProductCatalogState {
  loading: boolean;
  error: string | null;
  source: PepCatalogSource;
  productCount: number;
  refresh: () => Promise<void>;
}

export function useProductCatalog(pepApiBase?: string): UseProductCatalogState {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [source, setSource] = useState<PepCatalogSource>("static");
  const [productCount, setProductCount] = useState(0);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await loadPepProductCatalog(pepApiBase);
      setSource(result.source);
      setProductCount(result.products.length);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Catalogue indisponible");
      setSource("static");
      setProductCount(0);
    } finally {
      setLoading(false);
    }
  }, [pepApiBase]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { loading, error, source, productCount, refresh };
}
